import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { reparent as t, byId as s, empty as i } from "../core/domUtils.js";
import { addFrameTask as o } from "../core/scheduling.js";
import { init as r } from "../core/watchUtils.js";
import { property as n } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as h } from "../core/accessorSupport/decorators/subclass.js";
import a from "./overlay/ViewOverlay.js";
import d from "../widgets/Popup.js";
var u = [0, 0];

function l(e) {
  var t = (e.ownerDocument || window.document).defaultView,
      s = e.getBoundingClientRect();
  return u[0] = s.left + t.pageXOffset, u[1] = s.top + t.pageYOffset, u;
}

function p(e) {
  e && (i(e), e.parentNode && e.parentNode.removeChild(e));
}

function c(e) {
  var t = document.createElement("div");
  return e.appendChild(t), t;
}

var m = 16,
    f = 750,
    y = 512,
    v = 2,
    _ = function _(i) {
  var u = /*#__PURE__*/function (_i) {
    _inherits(u, _i);

    var _super = _createSuper(u);

    function u() {
      var _this;

      _classCallCheck(this, u);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(e)), _this._freqInfo = {
        freq: m,
        time: f
      }, _this._overlayRenderTaskHandle = null, _this.height = 0, _this.position = null, _this.resizing = !1, _this.root = null, _this.surface = null, _this.suspended = !0, _this.ui = null, _this.userContent = null, _this.width = 0, _this.widthBreakpoint = null, _this.handles.add([_this.watch("cursor", function (e) {
        var t = _this.surface;
        t && t.setAttribute("data-cursor", e);
      }), _this.watch("interacting", function (e) {
        var t = _this.surface;
        t && t.setAttribute("data-interacting", e.toString());
      })]);
      return _this;
    }

    _createClass(u, [{
      key: "initialize",
      value: function initialize() {
        var _this2 = this;

        this.handles.add(this.watch("ui", function (e, t) {
          return _this2._handleUIChange(e, t);
        })), this._wireUI(this.ui), this.handles.add([this.on("focus", function () {
          return _this2.notifyChange("focused");
        }), this.on("blur", function () {
          return _this2.notifyChange("focused");
        })]);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.destroyed || (this.ui && (this.ui.destroy(), this.ui = null), this.popup && !this.popup.destroyed && this.popup.destroy(), this.container = null);
      }
    }, {
      key: "container",
      set: function set(e) {
        var _this3 = this;

        var s = this._get("container");

        if (s === e) return;
        var i = "dom-size";

        if (this.handles.remove(i), this._stopMeasuring(), s && (s.classList.remove("esri-view"), this._overlayRenderTaskHandle && (this._overlayRenderTaskHandle.remove(), this._overlayRenderTaskHandle = null), this.overlay.destroy(), this._set("overlay", null), p(this.root), this._set("root", null), t(this.userContent, s), p(this.userContent), this._set("userContent", null)), e) {
          e.classList.add("esri-view");

          var _s = document.createElement("div");

          _s.className = "esri-view-user-storage", t(e, _s), e.appendChild(_s), this._set("userContent", _s);

          var _n = document.createElement("div");

          _n.className = "esri-view-root", e.insertBefore(_n, e.firstChild), this._set("root", _n);

          var _h = document.createElement("div");

          _h.className = "esri-view-surface", _h.setAttribute("role", "application"), _h.tabIndex = 0, _n.appendChild(_h), this._set("surface", _h);

          var _d = new a();

          _n.appendChild(_d.surface), this._set("overlay", _d), _d.watch("needsRender", function (e) {
            e && !_this3._overlayRenderTaskHandle ? _this3._overlayRenderTaskHandle = o({
              render: function render() {
                _this3.overlay.render();
              }
            }) : _this3._overlayRenderTaskHandle && (_this3._overlayRenderTaskHandle.remove(), _this3._overlayRenderTaskHandle = null);
          }), this.forceDOMReadyCycle(), this.handles.add(r(this, "size", function (e) {
            var _e = _slicedToArray(e, 2),
                t = _e[0],
                s = _e[1],
                i = "esri-view-surface--inset-outline";

            t >= document.body.clientWidth || s >= document.body.clientHeight ? _h.classList.add(i) : _h.classList.remove(i);
          }), i), this._set("container", e), this._startMeasuring();
        } else this._set("width", 0), this._set("height", 0), this._set("position", null), this._set("suspended", !0), this._set("surface", null), this._set("container", null);
      }
    }, {
      key: "focused",
      get: function get() {
        var e = document.activeElement === this.surface;
        return document.hasFocus() && e;
      }
    }, {
      key: "popup",
      get: function get() {
        return this._get("popup") || new d({
          view: this
        });
      },
      set: function set(e) {
        var t = this._get("popup");

        t && t !== e && t.destroy(), this._set("popup", e);
      }
    }, {
      key: "size",
      get: function get() {
        return [this.width, this.height];
      }
    }, {
      key: "blur",
      value: function blur() {
        this.surface && this.surface.blur();
      }
    }, {
      key: "focus",
      value: function focus() {
        this.surface && this.surface.focus();
      }
    }, {
      key: "pageToContainer",
      value: function pageToContainer(e, t, s) {
        var i = this.position;
        return e -= i[0], t -= i[1], s ? (s[0] = e, s[1] = t) : s = [e, t], s;
      }
    }, {
      key: "containerToPage",
      value: function containerToPage(e, t, s) {
        var i = this.position;
        return e += i[0], t += i[1], s ? (s[0] = e, s[1] = t) : s = [e, t], s;
      }
    }, {
      key: "_handleUIChange",
      value: function _handleUIChange(e, t) {
        t && (this.handles.remove("ui"), t.destroy()), e && this._wireUI(e), this._set("ui", e);
      }
    }, {
      key: "_wireUI",
      value: function _wireUI(e) {
        this.handles.remove("ui"), e && (e.view = this, this.handles.add([r(this, "root", function (t) {
          e.container = t ? c(t) : null;
        }), r(this, "popup", function (t, s) {
          var i = "popup",
              o = "manual";
          s && e.remove(s, i), t && (t.view = e.view, e.add(t, {
            key: i,
            position: o
          }));
        })], "ui"));
      }
    }, {
      key: "_stopMeasuring",
      value: function _stopMeasuring() {
        this.handles.remove("measuring"), this._get("resizing") && this._set("resizing", !1);
      }
    }, {
      key: "_startMeasuring",
      value: function _startMeasuring() {
        var _this4 = this;

        var e = this._freqInfo;
        e.freq = m, e.time = f, this.handles.add([function () {
          var t = function t() {
            e.freq = m, e.time = f;
          };

          return window.addEventListener("resize", t), {
            remove: function remove() {
              window.removeEventListener("resize", t);
            }
          };
        }(), o({
          prepare: function prepare(e) {
            var t = _this4._measure(),
                s = _this4._freqInfo;

            if (s.time += e.deltaTime, t && (s.freq = m, _this4._get("resizing") || _this4._set("resizing", !0)), s.time < s.freq) return;
            s.time = 0;

            var i = _this4._position();

            s.freq = i || t ? m : Math.min(f, s.freq * v), !t && s.freq >= y && _this4._get("resizing") && _this4._set("resizing", !1);
          }
        })], "measuring"), this._measure(), this._position();
      }
    }, {
      key: "_measure",
      value: function _measure() {
        var e = this.container,
            t = e ? e.clientWidth : 0,
            s = e ? e.clientHeight : 0;
        if (0 === t || 0 === s) return this.suspended || this._set("suspended", !0), !1;
        var i = this.width,
            o = this.height;
        return t === i && s === o ? (this.suspended && this._set("suspended", !1), !1) : (this._set("width", t), this._set("height", s), this.suspended && this._set("suspended", !1), this.emit("resize", {
          oldWidth: i,
          oldHeight: o,
          width: t,
          height: s
        }), !0);
      }
    }, {
      key: "_position",
      value: function _position() {
        var e = this.container,
            t = this.position,
            s = l(e);
        return (!t || s[0] !== t[0] || s[1] !== t[1]) && (this._set("position", [s[0], s[1]]), !0);
      }
    }, {
      key: "forceDOMReadyCycle",
      value: function forceDOMReadyCycle() {}
    }]);

    return u;
  }(i);

  return e([n({
    value: null,
    cast: function cast(e) {
      return s(e);
    }
  })], u.prototype, "container", null), e([n({
    readOnly: !0
  })], u.prototype, "focused", null), e([n({
    readOnly: !0
  })], u.prototype, "height", void 0), e([n({
    type: d
  })], u.prototype, "popup", null), e([n({
    type: a
  })], u.prototype, "overlay", void 0), e([n({
    readOnly: !0
  })], u.prototype, "position", void 0), e([n({
    readOnly: !0
  })], u.prototype, "resizing", void 0), e([n({
    readOnly: !0
  })], u.prototype, "root", void 0), e([n({
    value: null,
    readOnly: !0
  })], u.prototype, "size", null), e([n({
    readOnly: !0
  })], u.prototype, "surface", void 0), e([n({
    readOnly: !0
  })], u.prototype, "suspended", void 0), e([n()], u.prototype, "ui", void 0), e([n({
    readOnly: !0
  })], u.prototype, "userContent", void 0), e([n({
    readOnly: !0
  })], u.prototype, "width", void 0), e([n()], u.prototype, "widthBreakpoint", void 0), u = e([h("esri.views.DOMContainer")], u), u;
};

function g(e) {
  return e && "focus" in e;
}

export { _ as DOMContainer, g as isDOMContainer };